import { Head, Navbar, Footer } from './sections'

export default `
<html data-wf-page="6187c4ffefcbe9670f40d774" data-wf-site="617aeb5a738d7f6b279e7a99">
${Head}

<body class="bg-neutral-800">
  <div style="opacity:0" class="page-wrapper">
    ${Navbar}
    <section class="section home-hero wf-section">
      <div class="container-medium-940px home-hero">
        <div data-w-id="448f5ead-3667-0bad-b1a4-a6038870800b"
          style="-webkit-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="home-hero-featured-message-wrapper">
          <div class="home-hero-featured-message-content">
            <a data-w-id="5747d66c-b4ac-690f-6026-662ab3648be2"
              href="https://medium.com/@collabski/introduction-to-creator-partnerships-f6ba24800d63"
              class="home-hero-featured-message-link w-inline-block">
              <div class="home-hero-featured-message-tag">New</div>
              <div class="home-hero-featured-message-text">Haven&#x27;t worked with creators? Read our introductory
                guide!</div>
              <div class="home-hero-featured-message-icon"></div>
            </a>
            <div class="home-hero-featured-message-blur"></div>
          </div>
        </div>
        <h1 data-w-id="abc7287a-ad94-a3ec-8716-36750d55fc4e"
          style="-webkit-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="display-1 home-hero">Sponsor the creator<span class="text-color-accent"></span></h1>
        <h1 data-w-id="9ef644c1-95e1-0341-d985-5e989059c5c5"
          style="-webkit-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="display-1">you&#x27;re looking for<span class="text-color-accent"></span></h1>
        <p data-w-id="749e645b-3b65-110f-471d-f6af6dfbc601"
          style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="paragraph-large home-hero">The highly curated network of mechanical keyboard creators</p>
        <div data-w-id="b1ff49e2-6272-bd33-f83d-82e4206a6d65"
          style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="_2-buttons-wrapper">
          <div class="button-primary-gradient _2-buttons">
            <a href="/signup/brand" class="button-primary w-button">Sign up for free</a>
          </div>
        </div>
      </div>
      <div class="container-default home-hero w-container">
        <div data-w-id="1535d204-b8f5-78ad-1998-57322399a3bd"
          style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="home-hero-images-wrapper"><img src="https://d2vh08r8g1sliz.cloudfront.net/landing/hero-image.png"
            loading="lazy"
            sizes="(max-width: 479px) 84vw, (max-width: 767px) 82vw, (max-width: 991px) 84vw, (max-width: 1919px) 85vw, 1054.234375px"
            srcset="https://d2vh08r8g1sliz.cloudfront.net/landing/hero-image-p-500.png 500w, https://d2vh08r8g1sliz.cloudfront.net/landing/hero-image-p-800.png 800w, https://d2vh08r8g1sliz.cloudfront.net/landing/hero-image-p-1080.png 1080w, https://d2vh08r8g1sliz.cloudfront.net/landing/hero-image.png 2386w"
            alt="hero" class="image home-hero-1" /></div>
        <div class="home-hero-companies-wrapper">
          <div class="home-hero-companies">
            <img src="https://d2vh08r8g1sliz.cloudfront.net/landing/monstargear.svg" width="147" loading="lazy"
              alt="Monstar Gear" class="image home-hero-company">
            <img src="https://d2vh08r8g1sliz.cloudfront.net/landing/drop.svg" width="143" loading="lazy" alt="Drop.com"
              class="image home-hero-company google" />
            <img src="https://d2vh08r8g1sliz.cloudfront.net/landing/stacked.svg" width="176" loading="lazy"
              alt="Stacked.gg" class="image home-hero-company youtube" />
            <img src="https://d2vh08r8g1sliz.cloudfront.net/landing/moyu.svg" loading="lazy" alt="Moyu Studio"
              class="image home-hero-company" width="271" />
            <img src="https://d2vh08r8g1sliz.cloudfront.net/landing/capsule48.svg" width="130" loading="lazy"
              alt="Capsule 48" class="image home-hero-company" />
          </div>
        </div>
        <div data-w-id="a052a4bf-34f8-d790-1f5c-e2592094cb97" class="bg-gradient-blur-wrapper home-hero-1">
          <div class="bg-gradient-blur-circle-3"></div>
          <div class="bg-gradient-blur-circle-2"></div>
          <div class="bg-gradient-blur-circle-1"></div>
        </div>
        <div class="bg-gradient-blur-wrapper home-hero-2">
          <div class="bg-gradient-blur-circle-3"></div>
          <div class="bg-gradient-blur-circle-2 blue"></div>
          <div class="bg-gradient-blur-circle-1"></div>
        </div>
      </div>
    </section>
    <section class="section home-features reduction wf-section">
      <div class="container-medium-756px home-features">
        <h2 class="heading">Sponsorships made easy</h2>
        <p class="paragraph home-features">Collabski is an invite-only network of keyboard creators actively
          looking for their next sponsorship opportunity. We save you time in finding the right creator for your audience by being highly
          selective in our curation and streamlining the sponsorship process.</p>
      </div>
      <div class="container-default home-features w-container">
        <div class="w-layout-grid home-features-grid">
          <div class="card home-feature"><img
              src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-7-features-dark-template.svg" loading="lazy"
              alt="quality" class="image card-home-feature" />
            <div class="card-home-feature-content">
              <h3 class="title card-home-feature">High Quality Creators</h3>
              <p class="paragraph card-home-feature">We invite creators based on their previous collab work, number of
                impressions and content quality.</p>
            </div>
          </div>
          <div class="card home-feature"><img
              src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-2-features-dark-template.svg" loading="lazy"
              alt="statistics" class="image card-home-feature" />
            <div class="card-home-feature-content">
              <h3 class="title card-home-feature">Audience Statistics</h3>
              <p class="paragraph card-home-feature">Easily access information like demo, geo and other key information
                all on the same page.</p>
            </div>
          </div>
          <div class="card home-feature"><img src="https://d2vh08r8g1sliz.cloudfront.net/landing/Frame-37148.svg"
              loading="lazy" alt="Transparent prices" class="image card-home-feature" />
            <div class="card-home-feature-content">
              <h3 class="title card-home-feature">Transparent Prices</h3>
              <p class="paragraph card-home-feature">Eliminate guess work in sponsorship pricing by seeing what other
                brands are offering for placements.</p>
            </div>
          </div>
        </div>
        <div class="flex-vc home-features">
          <div class="_2-buttons-wrapper">
            <div class="button-primary-gradient _2-buttons">
              <a href="/signup/brand" class="button-primary w-button">Get started now</a>
            </div>
          </div>
        </div>
        <div class="bg-gradient-blur-wrapper big">
          <div class="bg-gradient-blur-circle-3 pink big"></div>
          <div class="bg-gradient-blur-circle-2"></div>
          <div class="bg-gradient-blur-circle-1 purple-2 big"></div>
        </div>
      </div>
    </section>
    <section class="section home-perks wf-section">
      <div class="container-default w-container">
        <div class="home-perks-wrapper">
          <div class="home-perks-content-top-wrapper">
            <div class="home-perks-content-top-content">
              <h2 class="title home-perks">Stand out from spam</h2>
              <p class="paragraph home-perks">Reach out to high quality content creators who want to work with your
                brand. Save time finding the right creator. </p>
              <div class="w-layout-grid home-perks-grid">
                <div class="home-perk-wrapper"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-password-dark-template.svg" loading="eager"
                    alt="Invite-only" class="image home-perk" />
                  <div class="home-perk-content">
                    <h3 class="title h4-size home-perk">Invite-only membership</h3>
                    <p class="paragraph home-perk">We invite creators based on relevance, size, content quality, and
                      professionalism. </p>
                  </div>
                </div>
                <div class="home-perk-wrapper"><img src="https://d2vh08r8g1sliz.cloudfront.net/landing/Frame-37154.svg"
                    loading="eager" alt="Guaranteed Response" class="image home-perk" />
                  <div class="home-perk-content">
                    <h3 class="title h4-size home-perk">Guaranteed responses</h3>
                    <p class="paragraph home-perk">Don&#x27;t get left on read. We make sure creators respond to every
                      offer.</p>
                  </div>
                </div>
                <div class="home-perk-wrapper"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-3-values-dark-template.svg" loading="eager"
                    alt="Active creators" class="image home-perk" />
                  <div class="home-perk-content">
                    <h3 class="title h4-size home-perk">Actively seeking partnerships</h3>
                    <p class="paragraph home-perk">Creators with profiles have the same goal as you, to find their next
                      partnership. </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-w-id="ee535ac1-ec9e-b9a8-d837-c86181eda861"
              style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
              class="image-wrapper home-perks-content-top-image"><img
                src="https://d2vh08r8g1sliz.cloudfront.net/landing/Discover-card.png" loading="eager"
                sizes="(max-width: 767px) 93vw, (max-width: 991px) 612px, (max-width: 1919px) 50vw, 612px"
                srcset="https://d2vh08r8g1sliz.cloudfront.net/landing/Discover-card-p-500.png 500w, https://d2vh08r8g1sliz.cloudfront.net/landing/Discover-card-p-800.png 800w, https://d2vh08r8g1sliz.cloudfront.net/landing/Discover-card.png 1224w"
                alt="Discover" /></div>
          </div>
          <div class="home-perks-content-bottom-wrapper">
            <div data-w-id="d33741e8-edd1-da97-3b24-7982c1abaa36"
              style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
              class="image-wrapper home-perks-content-bottom-image"><img
                src="https://d2vh08r8g1sliz.cloudfront.net/landing/Stats-card.png" loading="eager"
                srcset="https://d2vh08r8g1sliz.cloudfront.net/landing/Stats-card-p-500.png 500w, https://d2vh08r8g1sliz.cloudfront.net/landing/Stats-card-p-800.png 800w, https://d2vh08r8g1sliz.cloudfront.net/landing/Stats-card.png 1080w"
                sizes="(max-width: 767px) 93vw, (max-width: 991px) 612px, (max-width: 1919px) 50vw, 612px"
                alt="Creator Stats" class="image home-perks-content-bottom-image" /></div>
            <div class="home-perks-content-bottom-content">
              <h2 class="title home-perks">Get informed upfront</h2>
              <p class="paragraph home-perks">Get rid of back-and-forth conversations by getting decision-making info
                right from the start. <span class="text-no-wrap"></span></p>
              <div class="w-layout-grid home-perks-grid">
                <div class="home-perk-wrapper"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-2-features-dark-template.svg" loading="lazy"
                    alt="Stats" class="image home-perk" />
                  <div class="home-perk-content">
                    <h3 class="title h4-size home-perk">Audience statistics</h3>
                    <p class="paragraph home-perk">Get in-depth access to sizing, demographic and geographic data about
                      a creator&#x27;s audience.</p>
                  </div>
                </div>
                <div class="home-perk-wrapper"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-1-contact-categories-dark-template.svg"
                    loading="lazy" alt="Collabs" class="image home-perk" />
                  <div class="home-perk-content">
                    <h3 class="title h4-size home-perk">Past brand collaborations</h3>
                    <p class="paragraph home-perk">Understand a fit between a creator with easy access to all their past
                      brand collaborations.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="home-perks-content-top-wrapper">
            <div class="home-perks-content-top-content">
              <h2 class="title home-perks">No more price guessing</h2>
              <p class="paragraph home-perks">Make calculated offers based on transparent market data.<span
                  class="text-no-wrap"></span></p>
              <div class="w-layout-grid home-perks-grid">
                <div class="home-perk-wrapper"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-3-careers-perks-dark-template.svg"
                    loading="lazy" alt="Total offers" class="image home-perk" />
                  <div class="home-perk-content">
                    <h3 class="title h4-size home-perk">Total number of offers</h3>
                    <p class="paragraph home-perk">Get an idea of how in-demand a creator is by seeing how many other
                      brands are also interested.</p>
                  </div>
                </div>
                <div class="home-perk-wrapper"><img src="https://d2vh08r8g1sliz.cloudfront.net/landing/Frame-37148.svg"
                    loading="lazy" alt="Highest Offer" class="image home-perk" />
                  <div class="home-perk-content">
                    <h3 class="title h4-size home-perk">See the highest offer made</h3>
                    <p class="paragraph home-perk">Understand how competitive your offer is by seeing the highest offer
                      a brand has made. </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-w-id="24a66438-d00d-342a-e10f-1469d5035cdc"
              style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
              class="image-wrapper home-perks-content-top-image">
              <img
                src="https://d2vh08r8g1sliz.cloudfront.net/landing/Offer-specs-card.png" loading="eager"
                sizes="(max-width: 767px) 93vw, (max-width: 991px) 612px, (max-width: 1919px) 50vw, 612px"
                srcset="https://d2vh08r8g1sliz.cloudfront.net/landing/Offer-specs-card-p-500.png 500w, https://d2vh08r8g1sliz.cloudfront.net/landing/Offer-specs-card-p-800.png 800w, https://d2vh08r8g1sliz.cloudfront.net/landing/Offer-specs-card.png 1080w"
                alt="Offer Specs" class="image home-perks-content-top-image" /></div>
          </div>
          <div class="home-perks-content-bottom-wrapper last">
            <div data-w-id="eee63602-338e-2609-c779-cb867bac28ac"
              style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
              class="image-wrapper home-perks-content-bottom-image"><img
                src="https://d2vh08r8g1sliz.cloudfront.net/landing/Dashboard-card.png" loading="eager"
                sizes="(max-width: 767px) 93vw, (max-width: 991px) 612px, (max-width: 1919px) 50vw, 612px"
                srcset="https://d2vh08r8g1sliz.cloudfront.net/landing/Dashboard-card-p-500.png 500w, https://d2vh08r8g1sliz.cloudfront.net/landing/Dashboard-card-p-800.png 800w, https://d2vh08r8g1sliz.cloudfront.net/landing/Dashboard-card.png 1080w"
                alt="Your Dashboard" class="image home-perks-content-bottom-image" /></div>
            <div class="home-perks-content-bottom-content">
              <h2 class="title home-perks">Eyes on the prize </h2>
              <p class="paragraph home-perks">Easily access all your sponsorship deals with a dashboard built for
                readability. </p>
              <div class="w-layout-grid home-perks-grid">
                <div class="home-perk-wrapper"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-1-features-dark-template_1.svg"
                    loading="lazy" alt="Realtime updates" class="image home-perk" />
                  <div class="home-perk-content">
                    <h3 class="title h4-size home-perk">See updates in real time</h3>
                    <p class="paragraph home-perk">Track live updates to sponsorship offers made to your chosen creator.
                    </p>
                  </div>
                </div>
                <div class="home-perk-wrapper"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-3-contact-categories-dark-template.svg"
                    loading="lazy" alt="Past sponsorships" class="image home-perk" />
                  <div class="home-perk-content">
                    <h3 class="title h4-size home-perk">View all past sponsorships</h3>
                    <p class="paragraph home-perk">Keep a record of whom you&#x27;ve worked with and how much your team
                      has offered in the past.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section cta wf-section"></section>
    <section class="section home-steps wf-section">
      <div class="container-default w-container">
        <div class="home-steps-wrapper">
          <div class="split-content home-steps-left">
            <h2 class="heading-2">How it works</h2>
            <p class="paragraph home-steps">We designed the entire experience to help you do sponsorships faster and
              with more confidence.</p>
            <div class="button-primary-gradient">
              <a href="/signup/brand" class="button-primary w-button">Join for free</a>
            </div>
          </div>
          <div class="split-content home-steps-right">
            <div class="w-layout-grid home-steps-grid">
              <div data-w-id="66be55b7-13bf-9864-46c3-3b493748a167"
                style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
                class="card home-step">
                <div class="card-home-step-content">
                  <div class="title h3-size card-home-step-number">1</div>
                  <h3 class="title card-home-step">Find a creator listing</h3>
                  <p class="paragraph card-home-step">Creators list sponsorships for a set period of time for brands
                    to make offers. </p>
                </div>
                <div class="image-wrapper card-home-step"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/Find-a-creator-listing.png" loading="eager"
                    sizes="(max-width: 479px) 92vw, (max-width: 767px) 93vw, (max-width: 991px) 40vw, (max-width: 1919px) 26vw, 318.1875px"
                    srcset="https://d2vh08r8g1sliz.cloudfront.net/landing/Find-a-creator-listing-p-500.png 500w, https://d2vh08r8g1sliz.cloudfront.net/landing/Find-a-creator-listing.png 648w"
                    alt="Creator listing" class="image card-home-step" /></div>
              </div>
              <div data-w-id="b004a6e0-c506-f383-4ef2-7ba62c69ed92"
                style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
                class="card home-step">
                <div class="card-home-step-content">
                  <div class="title h3-size card-home-step-number">2</div>
                  <h3 class="title card-home-step">Place an offer</h3>
                  <p class="paragraph card-home-step">Work with creators the way you want. We support paid placement,
                    product-only, and affiliate offers.<span class="text-no-wrap"></span></p>
                </div>
                <div class="image-wrapper card-home-step"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/Place-an-offer.png" loading="eager"
                    sizes="(max-width: 479px) 92vw, (max-width: 767px) 93vw, (max-width: 991px) 40vw, (max-width: 1919px) 26vw, 318.1875px"
                    srcset="https://d2vh08r8g1sliz.cloudfront.net/landing/Place-an-offer-p-500.png 500w, https://d2vh08r8g1sliz.cloudfront.net/landing/Place-an-offer.png 648w"
                    alt="Place an offer" class="image card-home-step" /></div>
              </div>
              <div data-w-id="6ab9030c-f822-6a18-b144-9efcc7a7389b"
                style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
                class="card home-step">
                <div class="card-home-step-content">
                  <div class="title h3-size card-home-step-number">3</div>
                  <h3 class="title card-home-step">See live updates</h3>
                  <p class="paragraph card-home-step">See what other brands are offering and make updates
                    accordingly.<span class="text-no-wrap"></span></p>
                </div>
                <div class="image-wrapper card-home-step"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/See-live-updates.png" loading="lazy"
                    sizes="(max-width: 479px) 92vw, (max-width: 767px) 93vw, (max-width: 991px) 40vw, (max-width: 1919px) 26vw, 318.1875px"
                    srcset="https://d2vh08r8g1sliz.cloudfront.net/landing/See-live-updates-p-500.png 500w, https://d2vh08r8g1sliz.cloudfront.net/landing/See-live-updates.png 647w"
                    alt="Live updates" class="image card-home-step" /></div>
              </div>
              <div data-w-id="75ac40fd-fea7-3586-f026-0097732d5527"
                style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
                class="card home-step">
                <div class="card-home-step-content">
                  <div class="title h3-size card-home-step-number">4</div>
                  <h3 class="title card-home-step">Start the deal</h3>
                  <p class="paragraph card-home-step">Creators select the brands they want to work with. Multiple brands
                    can win a single sponsorship listing.<span class="text-no-wrap"></span></p>
                </div>
                <div class="image-wrapper card-home-step"><img
                    src="https://d2vh08r8g1sliz.cloudfront.net/landing/Start-the-deal.png" loading="lazy"
                    sizes="(max-width: 479px) 92vw, (max-width: 767px) 93vw, (max-width: 991px) 40vw, (max-width: 1919px) 26vw, 318.1875px"
                    srcset="https://d2vh08r8g1sliz.cloudfront.net/landing/Start-the-deal-p-500.png 500w, https://d2vh08r8g1sliz.cloudfront.net/landing/Start-the-deal.png 647w"
                    alt="Start deal" class="image card-home-step" /></div>
              </div>
            </div>
            <div class="bg-gradient-blur-wrapper home-steps">
              <div class="bg-gradient-blur-circle-3 pink"></div>
              <div class="bg-gradient-blur-circle-2 blue"></div>
              <div class="bg-gradient-blur-circle-1 purple"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section cta-last wf-section">
      <div class="container-default w-container">
        <div class="cta-card-wrapper">
          <div data-w-id="8848cb72-b24b-fd5b-4a1b-312ad063e45c" class="card cta">
            <h2 class="title card-cta">Access exclusive sponsorships</h2>
            <div class="_2-buttons-wrapper">
              <a href="/signup/brand" class="button-primary button-white _2-buttons w-button">Apply now</a>
              <a href="/pricing"
                class="button-secondary button-white-outline _2-buttons checkout-billing-address-toggle w-button">View
                pricing</a>
            </div>
          </div>
          <div data-w-id="8848cb72-b24b-fd5b-4a1b-312ad063e464" class="cta-gradient-blur"></div>
        </div>
      </div>
    </section>
    ${Footer}
  </div>
  <script src="https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=617aeb5a738d7f6b279e7a99"
    type="text/javascript" integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0="
    crossorigin="anonymous"></script>
  <script src="/landing/js/webflow.min.js" type="text/javascript"></script>
  <!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->
</body>

</html>
`
